import React, { useEffect, useState } from "react";
import Detail from "./detail";
import openBower from "./image/open_brower.png"
// 主组件
const App = () => {
  const [data, setData] = useState(null);
  const [logo, setLogo] = useState("");
  const [rn_app_info, setRnAppInfo] = useState("");
  const [contentId,setContentId]=useState("")
  const [isWeiXin,setIsWeiXin]=useState(false)
  useEffect(() => {
    HandleGetLogo();
    let search = window.location.search;
    let id;
    if (search) {
      let index = search.indexOf("?id");
      id = search.substring(index + 4, search.length);
      if (id) {
        setContentId(id)
        HandleGetToken(id);
      }
    }
  }, []);

  const getDetailData = (token, id) => {
    let detailUrl =
      "/dynamic/cm-sites-mmp/mf/getMediaFusionById?mediaFusionId=" + id;
    fetch(detailUrl, {
      method: "get",
      headers: {
        Authorization: "Bearer " + token,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        let host = window.location.origin;
        let data = res.data||{};
        data.host = host;
        document.title = data.title;
        setData(data);
      });
  };

  const HandleGetToken = (id) => {
    let loginUrl = "/dynamic/cm-sites-sys/v2/login";
    fetch(loginUrl, {
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: "loginType=touristLogin",
    })
      .then((res) => res.json())
      .then((res) => {
        if (res?.data?.data?.accessToken) {
          getDetailData(res.data.data.accessToken, id);
        }
      });
  };
  const HandleGetLogo = () => {
    let loginUrl = "/dynamic/cm-sites-sys/config/getConfigValuesByKeys";
    fetch(loginUrl, {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(["rn_app_logo","rn_app_info"]),
    })
      .then((res) => res.json())
      .then((res) => {
        setRnAppInfo(res.data.rn_app_info)
        setLogo(window.location.origin + res.data.rn_app_logo);
      });
  };

  const isAndroid = () => {
    const u = navigator.userAgent;
    if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
      return true;
    }

    return false;
  };
  return (
    <div
      style={{
        maxWidth: 677,
        height: document.documentElement.clientHeight,
        display: "flex",
        overflow: "scroll",
        position: "relative",
      }}
      className="titleContent"
    >
      {
        rn_app_info&&rn_app_info.download_android_link&&
        <div
        style={{
          width: "100%",
          height: 50,
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#fff",
        }}
      >
        <img src={logo} style={{ height: 30, marginLeft: 15 }} alt="" />
        <a
          onClick={() => {
            let ua = navigator.userAgent.toLowerCase();
            if (ua.indexOf("micromessenger") > -1) {
              setIsWeiXin(true)
            }else{
              window.location.href =rn_app_info.scheme_url+"?id="+contentId
              setTimeout(() => {
                let href = rn_app_info.download_ios_link;
                if (isAndroid()) {
                  href = rn_app_info.download_android_link;
                }
                window.location.href = href;
              }, 2000);
            }

            
          }}
          style={{
            width: 72,
            height: 26,
            fontSize: 12,
            borderRadius: 5,
            backgroundColor: "#ff0000",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            textDecoration: "none",
            marginRight: 15,
          }}
        >
          <span>打开APP</span>
        </a>
      </div>
      }
      
      <div style={{ marginTop:rn_app_info&&rn_app_info.download_android_link?50:0 }}>
        {data && (
          <Detail data={data} info={{ rn_app_info, isAndroid: isAndroid() }} />
        )}
      </div>
      {
        isWeiXin&& <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          backgroundColor: "rgba(0,0,0,0.7)",
          zIndex: 2,
          textAlign: "right",
        }}
      >
        <img
          src={openBower}
          style={{ width: 250, marginTop: 10, marginRight: 20 }}
        />
      </div>
      }
     
      <style>
        {`
          .titleContent::-webkit-scrollbar {  
            display: none; /* 隐藏滚动条的轨道 */  
            width: 0px;
          }
          `}
      </style>
    </div>
  );
};

export default App;
